export const environment = {
    production: false,
    isExternal: true,
    msalConfig: {
        auth: {
            clientId: '3ccdaae6-22c9-4277-a484-dfde442e0c91',
            authority: ""
        },
    },
    apiConfig: {
        scopes: ['openid profile offline_access 3ccdaae6-22c9-4277-a484-dfde442e0c91'],
        uri: 'https://pplfirsttest.onmicrosoft.com/3ccdaae6-22c9-4277-a484-dfde442e0c91/app.user',
    },
    b2cPolicies: {
        names: {
            signUpSignIn: 'B2C_1A_SIGNUP_SIGNIN',
            mfa: 'B2C_1A_STEPUP_MFA'
        },
        authorities: {
            signUpSignIn: {
                authority:
                    'https://pplfirsttest.b2clogin.com/pplfirsttest.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN',
            },
            mfa: {
                authority: 'https://pplfirsttest.b2clogin.com/pplfirsttest.onmicrosoft.com/B2C_1A_STEPUP_MFA'
            }
        },
        authorityDomain: 'pplfirsttest.b2clogin.com',
    },
    apiUrl: 'https://ngenapiext-tst2.pplfirst.com/external-tst2',
    mobileHealthUrl: 'https://www.mobilehealth.com/ny-cdpap-ppl-medical-screenings/',
    wotcUrl: 'https://sandbox.wotc.com/portal/public-partnerships-llc-sandbox/f8850?noStartDate=1',
    apimSubScriptionKey: '017f684c947a445281f09c2a9b121285',
    restrictedMenus: ["process_codes", "service_codes", "participant_provider_rates", "authorizations", "timesheets"],
    mfaTimeOutSeconds: 600
};